import { _errMissing, customError } from "@/app/errors"

export function errUnexpectedCalculationName(expected: string[], got: string) {
  return customError(
    "ERR-MU-01",
    `Missing calculation name ${got} in Calculations ${expected}.`
  )
}

export function errMissingDataInTermValues(type: string, ctx: Object) {
  return _errMissing("ERR-MU-02", `${type} values in Term values.`, ctx)
}

export function errMissingMetricInValues(name: string, ctx: Object) {
  return _errMissing("ERR-MU-03", `metric name: ${name}`, ctx)
}
